import { render } from "./HeroApprovalConferenceModal.vue?vue&type=template&id=0ef51e28&scoped=true"
import script from "./HeroApprovalConferenceModal.vue?vue&type=script&lang=js"
export * from "./HeroApprovalConferenceModal.vue?vue&type=script&lang=js"

import "./HeroApprovalConferenceModal.vue?vue&type=style&index=0&id=0ef51e28&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef51e28"]])

export default __exports__